/**
 * Client-only conceal/reveal helpers for authenticated CLARITY1 warranty PII.
 * Presentation state only — never persisted.
 */

/** Preserve the first two characters of the display name; mask later non-space characters. */
export function concealCustomerName(value: string): string {
  const raw = value ?? "";
  if (raw.length <= 2) return raw;
  const head = raw.slice(0, 2);
  const rest = raw
    .slice(2)
    .split("")
    .map((ch) => (/\s/.test(ch) ? ch : "•"))
    .join("");
  return `${head}${rest}`;
}

/**
 * Reveal only the first and last digit; mask intervening digits.
 * Non-digit formatting is preserved when it does not expose additional digits.
 */
export function concealContactNumber(value: string): string {
  const raw = value ?? "";
  const digitIndexes: number[] = [];
  for (let i = 0; i < raw.length; i += 1) {
    if (/\d/.test(raw[i]!)) digitIndexes.push(i);
  }
  if (digitIndexes.length <= 1) return raw;
  const first = digitIndexes[0]!;
  const last = digitIndexes[digitIndexes.length - 1]!;
  return raw
    .split("")
    .map((ch, i) => {
      if (!/\d/.test(ch)) return ch;
      if (i === first || i === last) return ch;
      return "•";
    })
    .join("");
}
